exports.createContentDigest=()=>"";